









































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import { DateRange } from '@/components/DatePicker.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';

interface ReportParams {
  date: DateRange;
  status: LabelValue | null;
  type: LabelValue | null;
  id: string;
  export: boolean;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
  },
  methods: {
    format,
  },
})
export default class ReportTable extends Vue {
  channel = { title: '', code: '', path: '' };

  listData: any[] = [];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  merchantCode = '';

  loading = false;
  showTable = false;

  format!: (val: string, cur?: boolean) => string;

  // eslint-disable-next-line class-methods-use-this
  openDetail(id: number, mc: string) {
    this.$router.push(`/auto-disbursement/other-business-report/${id}?merchant_code=${mc}`);
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  async getTransaction(params: ReportParams, page = 1, merchantCode = '') {
    if (merchantCode !== '') {
      this.loading = true;
      this.showTable = true;
      this.merchantCode = merchantCode;

      try {
        const date = {
          startDate: params.date.startDate === null ? undefined
            : dayjs(params.date.startDate).hour(0).minute(0).second(0)
              .format('YYYY-MM-DD HH:mm:ss'),
          endDate: params.date.endDate === null ? undefined
            : dayjs(params.date.endDate).hour(23).minute(59).second(59)
              .format('YYYY-MM-DD HH:mm:ss'),
        };

        const status = params.status === null || params.status.value === 'ALL' ? undefined : params.status.value;
        const action = params.type === null || params.type.value === 'ALL' ? undefined : params.type.value;
        const id = params.id === '' ? undefined : params.id;

        const { data } = await api.get('/prepaid/history/reseller', {
          params: {
            page,
            startDate: date.startDate,
            endDate: date.endDate,
            status,
            action,
            // eslint-disable-next-line @typescript-eslint/camelcase
            transaction_no: id?.replace(/\s/g, ''),
            // eslint-disable-next-line @typescript-eslint/camelcase
            merchant_code: merchantCode,
            // export: params.export ? true : undefined,
          },
        });

        if (params.export) {
          const downloadData = data as unknown as { path: string };
          this.loading = false;
          return downloadData.path;
        }

        this.loading = false;
        this.page = page;
        this.listData = data.data;
        this.totalPage = Math.ceil(data.total / data.per_page);
        this.from = data.from;
        this.to = data.to;
        this.totalItem = data.total;

        return null;
      } catch (err) {
        this.loading = false;
        this.showTable = false;
        throw err;
      }
    }

    return null;
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  @Prop(Boolean) readonly showFeeSharing!: boolean;
}
